import { MainContentArea, ContentHeader, ValueOrFallback } from "melco-ui";
import { useParams } from "react-router-dom";
import { useBreadcrumb } from "../../../hooks/navigation/useBreadcrumb";
import { ALL_PUBLISHED_STATES } from "../../../helper/publishedState";
import { useTranslation } from "react-i18next";
import { useFontCollection } from "../../../hooks/libraries/fontCollections/useFontCollection";
import { FontCollectionDuplicateButton } from "../../../components/libraries/fontCollections/FontCollectionDuplicateButton";
import { FontCollectionDetailMoreActionButton } from "../../../components/libraries/fontCollections/FontCollectionDetailMoreActionButton";
import { FontCollectionReferencesDrawer } from "../../../components/libraries/fontCollections/FontCollectionReferencesDrawer";
import { FontCollectionDetailForm } from "../../../components/libraries/fontCollections/FontCollectionDetailForm";
import { useGenericDrawer } from "melco-shared-logic";

export const FontCollectionDetails: React.FC = () => {
  const breadcrumb = useBreadcrumb(
    "libraries",
    "librariesFontCollectionsEmbroidery"
  );

  const { t } = useTranslation();

  const { fontCollectionId } = useParams<{
    fontCollectionId: string;
  }>();

  const {
    query: { data: fontCollection, refetch },
    queryKey,
  } = useFontCollection(fontCollectionId ?? "", ALL_PUBLISHED_STATES);

  const referencesDrawer = useGenericDrawer();

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={
            fontCollection && (
              <ValueOrFallback
                value={fontCollection.name}
                fallback={t("global.fallback.empty")}
              />
            )
          }
          breadcrumb={breadcrumb}
          extra={
            <>
              <FontCollectionDuplicateButton
                fontCollectionId={fontCollectionId ?? ""}
              />
              {fontCollection && (
                <FontCollectionDetailMoreActionButton
                  fontCollection={fontCollection}
                  referencesDrawer={referencesDrawer}
                />
              )}
            </>
          }
        />
      }
      contentPadding
    >
      {fontCollection && (
        <>
          <FontCollectionDetailForm
            fontCollection={fontCollection}
            refetch={refetch}
            referencesDrawer={referencesDrawer}
            queryKey={queryKey}
          />
          {fontCollection.id && (
            <FontCollectionReferencesDrawer
              drawer={referencesDrawer}
              id={fontCollection.id}
            />
          )}
        </>
      )}
    </MainContentArea>
  );
};
